import React, { useState,useRef } from 'react';
import { Box, Button, TextField, Typography, Paper, IconButton, InputAdornment, Avatar } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { fontFamily, keyframes } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function DoctorLoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const inputRefs = useRef([]);


  // To move to next textfield by pressing enter

  const handleKeyDown = (e, index) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const nextEl = inputRefs.current[index + 1];
      if (nextEl) {
        nextEl.focus();
      } else {
        handleDoctorLogin();
      }
    }
  };



  // Animated gradient keyframes for full-page background
  const pageGradient = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  `;

  const handleDoctorLogin = async () => {
    setLoading(true);
    try {
      const payload = {
        username: username,
        password: password
      };
      const res = await api.post('/auth/login', payload);
      const token = res.data.token;
       console.log(token);
      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('name', res.data.user.name);
        // Call onLogin to update auth state and then redirect
        onLogin();
        navigate('/doctor-chat-view');
      }
    } catch (err) {
      alert('Login failed: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center"
    sx={{
      position: 'relative', overflow: 'hidden', '::before': { content: '""', position: 'fixed', inset: 0, zIndex: 0, opacity: 0.8, transition: 'opacity 0.3s',
        background: 'linear-gradient(120deg, #e0f2f1, #b2dfdb, #80cbc4, #26a69a, #00897b)',
        backgroundSize: '300% 300%',
        animation: `${pageGradient} 12s ease-in-out infinite`,
      },
    }}
    >
      <Paper
        elevation={8}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: { xs: 3, sm: 4 }, 
              py: { xs: 4, sm: 5 }, width: { xs: '70%', sm: 400 }, minHeight: { xs: 'auto', sm: 420 }, borderRadius: 5, zIndex: 1, 
              background: '#f7fafc', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', boxShadow: '0 12px 30px rgba(0,0,0,0.2)', 
              border: '1px solid rgba(255,255,255,0.2)', 
            }}
      >
        <Avatar sx={{ bgcolor: '#26a69a', width: 64, height: 64, mb: 2, boxShadow: 2 }}>
          <LocalHospitalIcon sx={{ fontSize: 38, color: 'white' }} />
        </Avatar>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#004d40', mb: 0.5, fontSize: { xs: '1.4rem', sm: '1.6rem' }}}>Expert Login </Typography>
        <Typography variant="subtitle2" sx={{ color: '#00796b', mb: 3, fontSize: { xs: '0.85rem', sm: '0.95rem' } }} > Access the Expert Portal </Typography>
        <Box sx={{ width: '100%', maxWidth: 320 }}>
          <TextField
            label="Doctor Username"
            fullWidth
            margin="normal"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoComplete="username"
            sx={{ mb: 2, bgcolor: 'white', borderRadius: 2 }}
            inputRef={el => (inputRefs.current[0] = el)}
            onKeyDown={e => handleKeyDown(e, 0)}
          />
          <TextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}       
            autoComplete="current-password"
            inputRef={el => (inputRefs.current[1] = el)}
            onKeyDown={e => handleKeyDown(e, 1)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword((show) => !show)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
            sx={{ mb: 2, bgcolor: 'white', borderRadius: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            sx={{
              borderRadius: 3,
              fontWeight: 700,
              textTransform: 'none',
              bgcolor: '#26a69a',
              py: 1.3,
              fontSize: '1.1rem',
              mt: 1,
              boxShadow: 2,
              '&:hover': {
                bgcolor: '#00897b',
                boxShadow: 4,
              }
            }}
            onClick={handleDoctorLogin}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            size="large"
            sx={{
              borderRadius: 3,
              fontWeight: 700,
              textTransform: 'none',
              mt: 2,
              py: 1.3,
              borderColor: '#26a69a',
              color: '#00897b',
              fontSize: '1.1rem',
              '&:hover': {
                bgcolor: '#e0f2f1',
                borderColor: '#00897b',
                color: '#00897b',
              },
            }}
            onClick={() => navigate('/login')}
          >
            User Login
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default DoctorLoginPage; 